export const discover = {
  title: "さがす",
  available: "利用可能",
  coins: "コイン",
  list: {
    empty: "ユーザーが見つかりませんでした",
  },
  recentVideoCallSection: {
    title: "今すぐビデオ通話できる女の子",
    empty: "今すぐ通話できる女の子はいません。",
    minutesAgoCall: (args: { count: string | number }) =>
      `${args.count}分前に通話`,
    hoursAgoCall: (args: { count: string | number }) =>
      `${args.count}時間前に通話`,
    callButton: "発信",
  },
  liveSection: {
    title: "配信中の女の子",
    count: (args: { count: string | number }) => `(${args.count}人)`,
    empty: "配信中の女の子はいません。\n配信開始を待ちましょう。",
    enterConfirm: "配信に入室しますか？",
  },
  highReviewScoreSection: {
    title: "評価が高い女の子",
    empty: "評価が高い女の子はいません。",
  },
} as const;
